import React from 'react';
import './ModelAgnostic.css';

const modelIcons = [
  'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Microsoft_Azure.svg/330px-Microsoft_Azure.svg.png?20211008202712',
  'https://img.logo.dev/openai.com?token=live_6a1a28fd-6420-4492-aeb0-b297461d9de2&size=128&retina=false&format=png&theme=light',
  'https://img.logo.dev/salesforce.com?token=live_6a1a28fd-6420-4492-aeb0-b297461d9de2&size=128&retina=false&format=png&theme=light',
  'https://img.logo.dev/anthropic.com?token=live_6a1a28fd-6420-4492-aeb0-b297461d9de2&size=128&retina=false&format=png&theme=light',
  'https://img.logo.dev/meta.com?token=live_6a1a28fd-6420-4492-aeb0-b297461d9de2&size=128&retina=false&format=png&theme=light',
  'https://img.logo.dev/aleph-alpha.com?token=live_6a1a28fd-6420-4492-aeb0-b297461d9de2&size=128&retina=false&format=png&theme=light',
  'https://img.logo.dev/cohere.com?token=live_6a1a28fd-6420-4492-aeb0-b297461d9de2&size=128&retina=false&format=png&theme=light',
  'https://img.logo.dev/google.com?token=live_6a1a28fd-6420-4492-aeb0-b297461d9de2&size=128&retina=false&format=png&theme=light'
];

const shapedGrid = [
  [null, modelIcons[0], modelIcons[1], null],
  [modelIcons[2], modelIcons[3], modelIcons[4], modelIcons[5]],
  [null, modelIcons[6], modelIcons[7], null],
  [null, null, modelIcons[8], null]
];

const ModelAgnostic = () => {
  return (
    <section className="model-agnostic-section">
      <div className="model-agnostic-container">
        <h2 className="model-title">
          We are <span className="highlighted">Model Agnostic</span>
        </h2>
        <p className="section-description">
          XenaChat is model-agnostic, i.e., we are not dependent on one LLM provider.
          We dynamically routes between multiple AI models,
          speeding up responses and ensuring the best quality output with non-stop reliability.
        </p>
        <div className="shaped-icons-grid">
          {shapedGrid.map((row, rowIndex) => (
            <div className="shaped-row" key={rowIndex}>
              {row.map((icon, colIndex) => (
                <div className={`icon-wrapper ${icon ? '' : 'tile-placeholder'}`} key={colIndex}>
                  {icon && <img src={icon} alt={`model-${rowIndex}-${colIndex}`} />}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ModelAgnostic;
